import { invalidateCache } from 'api/urql/helpers/mutation';

export const markMessagesReadByJobs = (results, args, cache, info) => {
  // handlers go here
  invalidateCache('unreadMessagesInfo')(
    results,
    args,
    cache,
    info
  );
};
